export enum HybrisFieldTypes {
    Basic = 'BASIC',
    Full = 'FULL'
}